import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MainBusinessRecord } from '@core/models'
import { RecordFacadeService } from '@core/services/store-facade/record-facade.service'
import { TranslocoModule } from '@jsverse/transloco'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { take } from 'rxjs/operators'
import { SearchResultsItemComponent } from './search-results-item/search-results-item.component'

@UntilDestroy()
@Component({
    selector: 'app-search-results',
    templateUrl: './search-results.component.html',
    styleUrls: ['./search-results.component.sass'],
    imports: [SearchResultsItemComponent, TranslocoModule, MatIconModule],
})
export class SearchResultsComponent implements OnInit, OnChanges {
    private readonly recordFacadeService = inject(RecordFacadeService)

    @Input()
    searchValue?: string | null

    @Input()
    searchFilterValue?: string | null

    records!: MainBusinessRecord[] | null

    ngOnInit() {
        this.getRecords(this.searchValue)
    }

    getRecords(searchVal?: string | null) {
        this.recordFacadeService
            .selectAllRecords$()
            .pipe(untilDestroyed(this), take(10))
            .subscribe((records) => {
                if (records) {
                    this.records = records.filter((record) => {
                        return (
                            searchVal &&
                            record.name.value.toUpperCase().includes(searchVal.toUpperCase())
                        )
                    })
                }
            })
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!changes.searchValue) return
        const searchValue = changes?.searchValue?.currentValue

        if (searchValue) {
            this.getRecords(searchValue)
        } else {
            this.records = null
        }
    }
}
